GameView = require("views/base/game")

class GameMemoryView extends GameView
  templates:
    default: require("./template")
    tiles:   require("./components/tiles")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .tile": "selectTile"
    "iostap .goto-next": "next"

  serialize: ->
    data = super

    data.tiles = _.chain(data.tiles)
      .map(({ left, leftType, right, rightType }, i) ->
        if left? and right?
          [
            { content: left,  contentType: leftType,  index: i }
            { content: right, contentType: rightType, index: i }
          ]
        else
          []
      )
      .flatten()
      .shuffle()
      .each((t) ->
        if t.content.length > 20
          t.klass = "text-sm"
        else if t.content.length < 8
          t.klass = "text-lg"
      ).value()

    data

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

  initializeElements: ->
    super

    @setEl @findOne(".game-tiles"), "container"

  enterGame: ->
    @getEl("container").innerHTML = @templates.tiles(@serialize())
    @setEl @findAll(".tile"), "tiles"
    @elements.current = null

    super

  startGame: ->
    @game.timer.timestamp = Date.now()
    super

  selectTile: (e) ->
    prev = @getEl("current")
    next = e.currentTarget
    return if @game.timer.get("paused") or next.classList.contains("correct")

    next.classList.toggle("active")

    if prev
      @compareTiles(prev, next) if next.classList.contains "active"
      @elements.current = null
    else
      @setEl(next, "current")

  compareTiles: (prev, next) ->
    if prev isnt next and prev.dataset.index is next.dataset.index
      prev.classList.add "correct"
      next.classList.add "correct"
      prev.classList.add "active"
      next.classList.add "active"

      allTiles   = @getEl("tiles")
      doneTiles  = (t for t in allTiles when t.classList.contains("correct"))
      isComplete = doneTiles.length is allTiles.length
      isCorrect  = true

    else
      window.setTimeout (->
        prev.classList.remove "active"
        next.classList.remove "active"
      ), 1000

    if isCorrect
      @onCorrectAnswer
        score: 1000
        tally: true

      @game.timer.timestamp = Date.now()

    if isComplete
      window.setTimeout (_.bind @endGame, this), 1000


module.exports = GameMemoryView
